import React, { useContext, useEffect, useState } from "react";
// Soft UI Dashboard PRO React example components

import LoginLayout from "layouts/upstyled/SigninLayout";
import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

import { useParams, useLocation } from "react-router-dom";
import qs from "query-string";
import api from "services/api";
import { Link, Navigate } from "react-router-dom";
import toast from "react-hot-toast";
import moment from "moment";
import { decodeToken } from "react-jwt";

const VerifyEmail = (data) => {
  const [navUrl, setNavUrl] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [countDown, setCountDown] = useState(5);
  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;

  const urlObj = qs.parseUrl(url);
  let tokenObj = null;
  try {
    tokenObj = decodeToken(urlObj?.query?.token);
  } catch (e) {
    console.log(e);
  }

  useEffect(() => {
    verifyEmailAddress();
  }, []);

  useEffect(() => {
    if (isVerified == true) {
      const delayRedirecteFn = setTimeout(() => {
        const newCount = countDown - 1;
        setCountDown(newCount);
      }, 1000);
      if (countDown <= 0) {
        setNavUrl("/login");
      }
      return () => clearTimeout(delayRedirecteFn);
    }
  }, [countDown, isVerified]);

  const verifyEmailAddress = async () => {
    const payload = { email: urlObj?.query?.email, token: urlObj?.query?.token };
    try {
      await api.invitecode.verifyEmail(payload);

      setIsVerified(true);
    } catch (err) {
      let message = err?.response?.data?.message ? err.response.data.message : "Invalid link!";
      toast.error(message);
      setIsVerified(false);
    }
  };

  if (navUrl) {
    return <Navigate to={navUrl} />;
  }

  if (isVerified) {
    return (
      <LoginLayout>
        <div className="flex h-full w-full items-center justify-center">
          <Card className="flex min-h-[240px] bg-grey-0 rounded-rounded justify-center">
            <div className="flex flex-col py-12 w-full px-12 items-center">
              <div className="h-full flex flex-col gap-y-2 text-center items-center justify-center">
                <span className="inter-large-semibold text-grey-90 text-xl">
                  Welcome to UpStyled
                </span>
                <div className="inter-large-semibold text-grey-90 mt-2">
                  Your email address has been verified successfully, We will redirect you to login
                  page in {countDown} seconds...
                </div>
              </div>
            </div>
          </Card>
        </div>
      </LoginLayout>
    );
  } else if (tokenObj && tokenObj.exp < moment().unix()) {
    return (
      <LoginLayout>
        <div className="flex h-full w-full items-center justify-center">
          <Card className="flex min-h-[240px] bg-grey-0 rounded-rounded justify-center">
            <div className="flex flex-col py-12 w-full px-12 items-center">
              <div className="h-full flex flex-col gap-y-2 text-center items-center justify-center">
                <span className="inter-large-semibold text-grey-90 text-xl">
                  Your link was expired at {moment.unix(token.exp).format("YYYY-MM-DD HH:mm:ss")}
                </span>
                <span className="inter-base-regular text-grey-50 mt-2">
                  Please try to contact <a href="mailto:support@upstyled.co">support@upstyled.co</a>
                </span>
              </div>
            </div>
          </Card>
        </div>
      </LoginLayout>
    );
  } else {
    return (
      <LoginLayout>
        <div className="flex h-full w-full items-center justify-center">
          <Card className="flex min-h-[240px] bg-grey-0 rounded-rounded justify-center">
            <div className="flex flex-col py-12 w-full px-12 items-center">
              <div className="h-full flex flex-col gap-y-2 text-center items-center justify-center">
                <span className="inter-large-semibold text-grey-90 text-xl">
                  Your link is invalid
                </span>
                <span className="inter-base-regular text-grey-50 mt-2">
                  Please try to contact <a href="mailto:support@upstyled.co">support@upstyled.co</a>
                </span>
              </div>
            </div>
          </Card>
        </div>
      </LoginLayout>
    );
  }
};

export default VerifyEmail;
